import React, { useEffect } from 'react';
import { isUserAdmin } from '../utils/utils';
import { Button } from '@mui/material';
import moment from 'moment';
import DeleteButton from './DeleteButton';

const MessageItem = ({ date, message, onDelete }) => {
  return (
    <div className="bg-white p-4 rounded-md border-b border-b-gray-200 flex justify-between shrink-0 items-center">
      <div className="">
        <p className="text-gray-600 font-medium">{moment(date).local().format("YYYY-MM-DD HH:mm")}</p>
        <p className="text-gray-800">{message}</p>
      </div>

      {/* {isUserAdmin() && <Button variant="contained" color="error" onClick={onDelete} style={{ height: 'auto' }}>Delete</Button>} */}
      { isUserAdmin() && <DeleteButton onClick={onDelete}/>}
    </div>
  );
};

export default MessageItem;
